var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[('COMPLETED' !== _vm.item.state)?_c('span',[_vm._v(" "+_vm._s(_vm.$t(_vm.getCurrentStepTitle(_vm.item[_vm.headerId])))+" ")]):_c('span',[_vm._v(_vm._s(_vm.$t("general.done")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }